export default "__VITE_ASSET__DIoGDNEd__"